// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.main[data-v-2d885098] {\n    width: 60vw;\n}\n", ""]);
// Exports
module.exports = exports;
